import type { ThemeConfig } from "antd";

export const brandTokens = {
  primary: "#23715f",
  primaryDeep: "#174e43",
  cyan: "#3f8072",
  success: "#20856e",
  warning: "#b87a28",
  danger: "#c45157",
  ink: "#17231f",
  muted: "#68746e",
  canvas: "#f2f3f0",
  surface: "#ffffff",
  border: "#dfe3dd",
} as const;

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: brandTokens.primary,
    colorInfo: brandTokens.primary,
    colorSuccess: brandTokens.success,
    colorWarning: brandTokens.warning,
    colorError: brandTokens.danger,
    colorText: brandTokens.ink,
    colorTextSecondary: brandTokens.muted,
    colorBgLayout: brandTokens.canvas,
    colorBorderSecondary: brandTokens.border,
    borderRadius: 7,
    borderRadiusLG: 9,
    controlHeight: 38,
    fontFamily:
      "'Noto Sans SC Variable', Inter, 'SF Pro Display', 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif",
    boxShadowSecondary: "0 18px 50px rgba(24, 42, 34, 0.14)",
  },
  components: {
    Button: {
      borderRadius: 7,
      fontWeight: 600,
      primaryShadow: "0 7px 18px rgba(35, 113, 95, 0.2)",
    },
    Card: {
      borderRadiusLG: 10,
      boxShadowTertiary: "0 8px 30px rgba(26, 42, 34, 0.05)",
    },
    Input: { activeShadow: "0 0 0 3px rgba(35, 113, 95, 0.1)" },
    Menu: { itemBorderRadius: 6, itemMarginInline: 10 },
    Table: {
      headerBg: "#f3f5f2",
      headerColor: "#52605a",
      rowHoverBg: "#f3f8f5",
    },
    Tag: { borderRadiusSM: 999 },
  },
};
